import React from 'react';
import styles from './TokenChips.module.css';

// {{token}} personalization variables — resolved per-recipient at send time
// by pmw-click-backend's src/utils/personalization.util.js, the same choke
// point real campaign sends and journey sends both already go through.
// total_earning isn't offered yet — it isn't a stored value anywhere today,
// see that file's own comment for why.
const TOKENS = [
  { key: 'name', label: 'Name' },
  { key: 'city', label: 'City' },
  { key: 'state', label: 'State' },
  { key: 'pickmywork_id', label: 'PickMyWork ID' },
];

// For plain free-text fields (title/body/subject/html/text) — adds a space
// before the token unless the field is empty or already ends in whitespace,
// so clicking a chip doesn't run it straight into existing text.
export function appendToken(current, token) {
  if (!current || /\s$/.test(current)) return current + token;
  return `${current} ${token}`;
}

// Appends `{{token}}` to the end of the current value rather than inserting
// at the cursor — these are plain controlled inputs with no ref forwarding,
// and that plumbing isn't worth it just for this. The text is still freely
// editable afterward.
class TokenChips extends React.Component {
  render() {
    const { onInsert } = this.props;
    return (
      <div className={styles.wrap}>
        <span className={styles.label}>Insert:</span>
        {TOKENS.map((t) => (
          <button key={t.key} type="button" className={styles.chip} onClick={() => onInsert(`{{${t.key}}}`)}>
            {t.label}
          </button>
        ))}
      </div>
    );
  }
}

export default TokenChips;
